<template>
    <div class="panel">
        <div class="panel-body" style="padding:15px;">

        <ul class="nav nav-pills" style="margin-bottom:25px;">
            <li class="nav-item">
                <router-link class="nav-link active" :to="'/pacotes/'+$route.params.id+'/editar'">Cargas</router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" :to="'/pacotes/'+$route.params.id+'/editar'">Config.</router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" :to="'/pacotes/'+$route.params.id+'/itinerario'">Itinerário</router-link>
            </li>
            <li class="nav-item">
                <router-link class="nav-link" :to="'/pacotes/'+$route.params.id+'/relatorio'">Relatório</router-link>
            </li>
        </ul>
        
        <div class="menu-pacote">
            <div v-for="carga in cargas" v-bind:key="carga.id">
                <router-link :to="'/pacotes/'+pacote_id+'/carga/'+carga.id">

                    <div :class="isActive(carga.id)">
                        
                        <strong class="placas">
                            
                            <span v-if="carga.hasOwnProperty('veiculos')!==true" class="cavalo">
                                    INDEFINIDO
                            </span>

                            <span v-for="(veiculo, index) in carga.veiculos" v-bind:key="index">
                                <span v-if="carga.veiculos.length>0" :class="isHorse(index)">
                                    {{veiculo.placa.replace('-','')}}, 
                                </span>
                            </span>

                        </strong><br>
                        <small class="carga">{{carga.item}} - {{carga.nome}}</small>

                        <div class="obs" v-if="1==2">
                            Aet com problema no DER-PR. Será necessário pedir alteração de validade das AETs.
                        </div>

                    </div>

                </router-link>
            </div>
        </div>

        </div>
    </div>
</template>

<script>
    import config from '@/config'

    export default {
        name:"MenuPacote",
        data(){
            return{
                config:config,
                pacote_id:null,
                cargas:{}
            }
        },
        methods:{
            Listar(){
                this.$http.get(this.config.API+"cargas/"+this.pacote_id)
                .then(res => {
                    this.cargas = res.data.data.map(r => {
                        if(r.conjunto){
                            if(r.conjunto.veiculos){
                                let veiculos = JSON.parse(r.conjunto.veiculos)
                                r['veiculos'] = veiculos
                            }
                        }
                        return r
                    })
                })
            },

            isActive(id){
                if(this.$route.params.carga==id){
                    return 'item-pacote active'
                }else{
                    return 'item-pacote'
                }
            },

            isHorse(i){
                if(i==0){
                    return 'cavalo'
                }
            }


        },
        beforeMount(){
            this.pacote_id = this.$route.params.id
            this.Listar()
        }
    }
</script>


<style scoped>
    
    .menu-pacote{
        text-transform: uppercase;
    }

    .menu-pacote a, a:hover{
        text-decoration: none;
    }

    .menu-pacote .item-pacote{
        border-radius:4px;
        margin-bottom:8px;
        padding:12px;
        color:#000;
        line-height: 120%;
        border: solid 1px #E7ECF2;
    }

    .menu-pacote .item-pacote .placas{
        color:#313139;
        font-weight: 600;
        font-size: 11pt;
    }

    .menu-pacote .item-pacote .placas .cavalo{
    }

    .menu-pacote .item-pacote .carga{
        font-weight:500;
        font-size: 9pt;
         text-transform: lowercase !important;
    }

    .menu-pacote .item-pacote .obs{
        font-size:9pt;
        text-transform:initial !important;
        line-height:120%;
        margin-top:5px;
        margin-bottom:5px;
        font-weight:500;
        font-style: italic;
    }

    .menu-pacote .active, .menu-pacote .active:hover{
        background-color:#D5EEC9 !important;
        border: solid 1px #c3e4b3;
    }

    .menu-pacote .item-pacote:hover{
        background: #F5F7F9;
        transition: 0.5s;
    }



</style>